/**
 * FILTER TOGGLE CUSTOM ELEMENT
 *
 * Wraps a trigger button (rendered in Liquid, outside the Preact app) and, on click,
 * dispatches a global `filters.open` event on `window`. The Athos FiltersProvider
 * listens for this event and opens the filter/sort drawer.
 *
 * This keeps the trigger fully decoupled from the Preact app — no DOM querying or
 * cross-component button clicking. Any element can open the drawer by dispatching the
 * same event.
 *
 * Usage:
 *   <filter-toggle>
 *     <button aria-label="Toggle Filters">Filter & Sort</button>
 *   </filter-toggle>
 */

export const FILTERS_OPEN_EVENT = 'filters.open'

export class FilterToggle extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick)
  }

  handleClick = () => {
    window.dispatchEvent(new CustomEvent(FILTERS_OPEN_EVENT))
  }
}
